<template>
    <div :id="modalId" uk-modal>
        <div class="uk-modal-dialog uk-modal-dialog-wide uk-modal-body business-unit-form">
            <h2 class="uk-modal-title">{{ name }}</h2>
            <form ref="form" class="">
                <div class="uk-grid">
                    <div  v-if="logoPath" class="uk-width-2-3 uk-form-controls js-upload" uk-form-custom>
                        <img :src="logoPath + '/0/65'" />
                    </div>
                    <div class="uk-width-1-4 uk-form-controls">
                        <label class="uk-form-label">Status</label>
                        <div class="status" :class="{active:isActive, inactive:!isActive}">
                            {{ status }}
                        </div>
                    </div>
                </div>
                <div class="uk-grid">
                    <div class="uk-width-1-2 uk-form-controls">
                        <label class="uk-form-label">Unit Name</label>
                        <div>
                            {{ name }}
                        </div>
                    </div>
                </div>
                <div class="uk-grid">
                    <div class="uk-width-1-2 uk-form-controls">
                        <label class="uk-form-label">Project Prefix</label>
                        <div>
                            {{ project_prefix }}
                        </div>
                    </div>
                </div>
                <div class="uk-grid">
                    <div class="uk-width-1-2">
                        <div>
                            <label class="uk-form-label">Address 1</label>
                            <div class="uk-form-controls">
                                {{ location.address1 }}
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-2">
                        <div>
                            <label class="uk-form-label">Address 2</label>
                            <div class="uk-form-controls">
                                {{ location.address2 }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="uk-grid uk-margin-small-top">
                    <div class="uk-width-1-3">
                        <div>
                            <label class="uk-form-label">City</label>
                            <div class="uk-form-controls">
                                {{ location.city }}
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-3">
                        <div>
                            <label  class="uk-form-label">State</label>
                            <div class="uk-form-controls">
                                {{ location.state !== "" ? states[location.state]:"" }}
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-3">
                        <div>
                            <label class="uk-form-label">Zip Code</label>
                            <div class="uk-form-controls">
                                {{ location.postal }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="uk-grid uk-margin-small-top">
                    <div class="uk-width-1-3 uk-form-controls">
                        <label class="uk-form-label">Current Requisitions</label>
                        <div>
                            {{ numRequisitions }}
                        </div>
                    </div>
                    <div class="uk-width-1-3 uk-form-controls">
                        <label class="uk-form-label">Employees</label>
                        <div>
                            {{ numEmployees }}
                        </div>
                    </div>
                    <div class="uk-width-1-3 uk-form-controls">
                        <label class="uk-form-label">Manager</label>
                        <div v-for="manager in managers">
                            {{ manager.full_name }}
                        </div>
                    </div>
                </div>
            </form>
            <div class="divider uk-margin"></div>
            <ul class="uk-tab" uk-switcher="animation: uk-animation-fade">
                <li class="uk-active"><a href="#current-job">Current Jobs</a></li>
                <li><a href="#archives">Jobs Archive</a></li>
            </ul>
            <ul class="uk-switcher">
                <li class="uk-container uk-container-expand minimal-table">
                    <data-table
                        ref="bu_requisitions"
                        :searchable="false"
                        :api_point="activeApi"
                        :per_page="30"
                        :search_on_start=false
                        :table_headers="{customer:{display:'Customer Name', sortable:false},
                            number:{display:'Requisition Code', sortable:false},
                            employee_count:{display:'# of Employees', sortable:false},
                            start_date_calc:{display:'Start Date', sortable:false},
                            end_date_calc:{display:'End Date', sortable:false}
                        }"
                    ></data-table>
                    <div class="uk-margin-small-bottom"></div>
                </li>
                <li class="uk-container uk-container-expand minimal-table">
                    <data-table
                        ref="bu_archived_requisitions"
                        :searchable="false"
                        :api_point="archivedApi"
                        :per_page="30"
                        :search_on_start=false
                        :table_headers="{customer:{display:'Customer Name', sortable:false},
                            number:{display:'Requisition Code', sortable:false},
                            employee_count:{display:'# of Employees', sortable:false},
                            start_date_calc:{display:'Start Date', sortable:false},
                            end_date_calc:{display:'End Date', sortable:false}
                        }"
                    ></data-table>
                    <div class="uk-margin-small-bottom"></div>
                </li>
            </ul>
            <div class="divider uk-margin"></div>
            <button class="uk-button uk-button-primary uk-modal-close" type="button" :uk-toggle="'target: #' + formModalId" @click="editForm">Edit</button>
            <button class="uk-button uk-button-tertiary uk-modal-close" type="button" @click="cancel()">Cancel</button>
        </div>
    </div>
</template>
<script>
    export default {

        props: {
            modalId:String,
            formModalId:String,
            formRef:String,
            title:String,
            get:String
        },

        data(){
            return {
                id:null,
                logoPath:null,
                uploadPath:"",
                imageSelected: false,
                status:"active",
                name:"",
				project_prefix:"",
                managerId:0,
				managers: [],
                employees:{},
                numEmployees:0,
                numRequisitions:0,
                states:{},
                location: {
                    address1:"",
                    address2:"",
                    city:"",
                    state:"",
                    postal:""
                },
                activeApi:"bu/requisitions/",
                archivedApi:"bu/requisitions-archived/",
            }
        },

        mounted() {
            axios.get("/api/forms/states").then(
                (pack) => this.updateStateList(pack)
            );
            axios.get("/api/forms/employees").then(
                (pack) => this.updateEmployeeList(pack)
            );
        },

        methods: {
            editForm(){
                this.$root.$refs[this.formRef].loadForm(this.id);
            },
            cancel() {
                this.clearForm();
            },
            updateForm(){
                this.clearForm();
                if(this.table){
                    this.$root.$refs[this.table].startSearch();
                }
            },
            clearForm(){
                if(this.id){
                    this.id = null;
                    this.$refs.form.reset();
                    this.status = "active";
                    this.logoPath = null;
                    this.name="";
                    this.project_prefix="";
                    this.managerId=0;
                    this.managers = [],
                    this.location= {
                        address1:"",
                            address2:"",
                            city:"",
                            state:"",
                            postal:""
                    };
                    this.imageSelected = false;
                }
            },
            loadForm(id){
                this.id = id;
                axios.get(this.ensureEndingSlash(this.get) + id).then((pack) => this.updateFormData(pack));
                this.activeApi = "bu/requisitions/" + id;
                this.archivedApi = "bu/requisitions-archived/" + id;
                setTimeout(() => this.updateTables(),0);
            },
            updateTables(){
                this.$refs.bu_requisitions.startSearch();
                this.$refs.bu_archived_requisitions.startSearch();
            },
            updateFormData(pack){
                let data = pack.data.data;

                this.name = data.name;
                this.project_prefix = data.project_prefix;
                this.location = data.location;
                this.managerId = data.manager_id;
                this.managers = data.managers;
                this.status = data.status;
                this.numEmployees = data.num_employees;
                this.numRequisitions = data.num_requisitions;

                this.logoPath = data.logo ? data.logo.url:null;
                this.imageSelected = false;
            },
            ensureEndingSlash(str){
                let lastChar = str.substr(str.length - 1);
                if(lastChar != "/"){
                    return str + "/";
                }
                return str;
            },
            updateStateList(pack) {
                if(pack.data.success){
                    this.states = pack.data.data;
                }
            },
            updateEmployeeList(pack) {
                if(pack.data.success){
                    this.employees = pack.data.data;
                }
            },
            imageChanged(e){
                if(e.target.files.length > 0){
                    this.imageSelected = true;
                }
            }
        },

        computed:{
            isActive(){
                return this.status == "active";
            }
        }

    }
</script>
